import React, { useEffect, useRef } from "react";

import { getOverlappingDaysInIntervals } from "date-fns/esm";
import Button from "devextreme-react/button";
import { useDispatch, useSelector } from "react-redux";
import Balancer from "react-wrap-balancer";

import { selectUiDrawerInsider } from "@app/state";
import { useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { Icon } from "@iconify/react";

import { useAppFusion } from "../../contexts";
import { inLogin } from "../../state/insider/login";
import "../../style/dx.generic.teamZebra.min.css";
import "./notAuth.scss";

const VerificationRequired = () => {
  const { refreshToken } = useAppFusion();
  return (
    <div>
      <div id="jgap-main" className="not-authenticated">
        <div className="appbody">
          <Button
            width={464}
            height={64}
            stylingMode={"text"}
            text={
              "Click dupa ce verificati casuta de email si validati inregistrarea."
            }
            icon={"email"}
            onClick={() => {
              refreshToken();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export const InsiderNotSynced = ({
  body,
  closeInsider,
}: {
  body: string;
  closeInsider?: () => void;
}) => {
  const email = "support@jurnalgold.ro";
  const subject = "Contul de Admin Panel nu este sincronizat cu baza Insider";
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;

  return (
    <div>
      <div
        id="jgap-main"
        className="not-authenticated"
        style={{ background: "transparent" }}
      >
        <div className="appbody">
          <div>
            <Balancer>
              {"Contul dvs de Admin Panel nu este sincronizat cu baza Insider."}
            </Balancer>
          </div>
          <div>
            <Balancer>
              Luati legatura cu administratorul sau scrieti la{" "}
              <a href={mailtoLink}>support@jurnalgold.ro</a>
            </Balancer>
          </div>
          {/* <Button
            style={{marginTop:"0.7rem"}}
            stylingMode={"text"}
            text={"Inchide"}
            icon={"close"}
            onClick={() => {
              closeInsider() // NO CLOSE EVENT READY... TO DO
            }}
          /> */}
        </div>
      </div>
    </div>
  );
};

export const MessageUnderConstruction = ({
  buttonVisible,
  buttonClick,
  children,
}: {
  buttonVisible?: boolean;
  buttonClick?: () => void;
  children?: React.ReactNode;
}) => {
  return (
    <div>
      <div
        id="jgap-main"
        className="not-authenticated"
        style={{ background: "transparent" }}
      >
        <div className="appbody">
          <Icon icon="line-md:construction" color="#5f8bce" width="84" />
          {children}
          {buttonVisible && buttonClick && (
            <Button
              style={{ marginTop: "0.7rem" }}
              stylingMode={"text"}
              text={"Inchide"}
              icon={"close"}
              onClick={() => buttonClick()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const WorkInProgress = () => {
  return (
    <div>
      <div
        id="jgap-main"
        className="not-authenticated"
        style={{ background: "transparent" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Icon icon="line-md:cog-loop" color="#5f8bceA7" width="184" />
          <div>
            <Balancer>
              {"Pagina in lucru. Va rugam reveniti mai tarziu."}
            </Balancer>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LoginToInsider = ({
  ClientName,
  gEmail,
}: {
  ClientName: string;
  gEmail: string;
}) => {
  const loginRequestSent = useRef(false);
  const dipatch = useDispatch();
  const perseed = useSelector(selectUiDrawerInsider);

  useEffect(() => {
    if (!loginRequestSent.current) {
      loginRequestSent.current = true;
      dipatch(inLogin(gEmail));
      // fxDispatch(
      //   sfxInLogin({
      //     email: gEmail,
      //     perseed,
      //   })
      // );
    }
  }, []);
  return (
    <div>
      <div
        id="jgap-main"
        className="not-authenticated"
        style={{ background: "transparent" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Icon
            icon="line-md:weather-cloudy-loop"
            color="#5f8bce"
            width="184"
          />
          <div>
            <Balancer>{`Autentificare la Jurnal Gold Insider`}</Balancer>
          </div>
          <div>
            <Balancer>{ClientName}</Balancer>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LoadingPage = () => {
  const message = useFxSelector(schema.loaderText.select);
  const progress_ = useFxSelector(schema.loaderBootProgress.select);
  //format double to two decimals
  const progress = progress_.toFixed(2);

  return (
    <div>
      <div
        id="jgap-main"
        className="not-authenticated insider"
        style={{ background: "transparent" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="192"
            height="192"
            viewBox="0 0 24 24"
          >
            <rect width="7.33" height="7.33" x="1" y="1" fill="#5f8bceA7">
              <animate
                id="svgSpinnersBlocksWave0"
                attributeName="x"
                begin="0;svgSpinnersBlocksWave1.end+0.44s"
                dur="1.32s"
                values="1;4;1"
              />
              <animate
                attributeName="y"
                begin="0;svgSpinnersBlocksWave1.end+0.44s"
                dur="1.32s"
                values="1;4;1"
              />
              <animate
                attributeName="width"
                begin="0;svgSpinnersBlocksWave1.end+0.44s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="0;svgSpinnersBlocksWave1.end+0.44s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
            <rect width="7.33" height="7.33" x="8.33" y="1" fill="#5f8bceA7">
              <animate
                attributeName="x"
                begin="svgSpinnersBlocksWave0.begin+0.22s"
                dur="1.32s"
                values="8.33;11.33;8.33"
              />
              <animate
                attributeName="y"
                begin="svgSpinnersBlocksWave0.begin+0.22s"
                dur="1.32s"
                values="1;4;1"
              />
              <animate
                attributeName="width"
                begin="svgSpinnersBlocksWave0.begin+0.22s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="svgSpinnersBlocksWave0.begin+0.22s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
            <rect width="7.33" height="7.33" x="1" y="8.33" fill="#5f8bceA7">
              <animate
                attributeName="x"
                begin="svgSpinnersBlocksWave0.begin+0.22s"
                dur="1.32s"
                values="1;4;1"
              />
              <animate
                attributeName="y"
                begin="svgSpinnersBlocksWave0.begin+0.22s"
                dur="1.32s"
                values="8.33;11.33;8.33"
              />
              <animate
                attributeName="width"
                begin="svgSpinnersBlocksWave0.begin+0.22s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="svgSpinnersBlocksWave0.begin+0.22s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
            <rect width="7.33" height="7.33" x="15.66" y="1" fill="#5f8bceA7">
              <animate
                attributeName="x"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="15.66;18.66;15.66"
              />
              <animate
                attributeName="y"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="1;4;1"
              />
              <animate
                attributeName="width"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
            <rect width="7.33" height="7.33" x="8.33" y="8.33" fill="#5f8bceA7">
              <animate
                attributeName="x"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="8.33;11.33;8.33"
              />
              <animate
                attributeName="y"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="8.33;11.33;8.33"
              />
              <animate
                attributeName="width"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
            <rect width="7.33" height="7.33" x="1" y="15.66" fill="#5f8bceA7">
              <animate
                attributeName="x"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="1;4;1"
              />
              <animate
                attributeName="y"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="15.66;18.66;15.66"
              />
              <animate
                attributeName="width"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="svgSpinnersBlocksWave0.begin+0.44s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
            <rect
              width="7.33"
              height="7.33"
              x="15.66"
              y="8.33"
              fill="#5f8bceA7"
            >
              <animate
                attributeName="x"
                begin="svgSpinnersBlocksWave0.begin+0.66s"
                dur="1.32s"
                values="15.66;18.66;15.66"
              />
              <animate
                attributeName="y"
                begin="svgSpinnersBlocksWave0.begin+0.66s"
                dur="1.32s"
                values="8.33;11.33;8.33"
              />
              <animate
                attributeName="width"
                begin="svgSpinnersBlocksWave0.begin+0.66s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="svgSpinnersBlocksWave0.begin+0.66s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
            <rect
              width="7.33"
              height="7.33"
              x="8.33"
              y="15.66"
              fill="#5f8bceA7"
            >
              <animate
                attributeName="x"
                begin="svgSpinnersBlocksWave0.begin+0.66s"
                dur="1.32s"
                values="8.33;11.33;8.33"
              />
              <animate
                attributeName="y"
                begin="svgSpinnersBlocksWave0.begin+0.66s"
                dur="1.32s"
                values="15.66;18.66;15.66"
              />
              <animate
                attributeName="width"
                begin="svgSpinnersBlocksWave0.begin+0.66s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="svgSpinnersBlocksWave0.begin+0.66s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
            <rect
              width="7.33"
              height="7.33"
              x="15.66"
              y="15.66"
              fill="#5f8bceA7"
            >
              <animate
                id="svgSpinnersBlocksWave1"
                attributeName="x"
                begin="svgSpinnersBlocksWave0.begin+0.88s"
                dur="1.32s"
                values="15.66;18.66;15.66"
              />
              <animate
                attributeName="y"
                begin="svgSpinnersBlocksWave0.begin+0.88s"
                dur="1.32s"
                values="15.66;18.66;15.66"
              />
              <animate
                attributeName="width"
                begin="svgSpinnersBlocksWave0.begin+0.88s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
              <animate
                attributeName="height"
                begin="svgSpinnersBlocksWave0.begin+0.88s"
                dur="1.32s"
                values="7.33;1.33;7.33"
              />
            </rect>
          </svg>
          <div>
            <Balancer>{message || "Se incarca..."}</Balancer>
            <div>{`${progress} %`}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationRequired;
